
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/Hooks/useKeyPress.html",
      function () {
        return require("private-next-pages/Hooks/useKeyPress.html.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/Hooks/useKeyPress.html"])
      });
    }
  